import React from "react";
import { AiFillHtml5 } from "react-icons/ai";
import {
  DiCss3,
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiWordpress,
} from "react-icons/di";

import "./experiences.css";

const Experiences = () => {
  return (
    <section id="experiences">
      <h5> The skills i have</h5>
      <h2> My Experience</h2>
      <div className=" container experience__container">
        <div className="experience__item">
          <div className="experience__item-icon">
            <AiFillHtml5 />
          </div>
          <div className="experience__item-text">
            <h3 className="text-light">HTML</h3>
          </div>
        </div>
        <div className="experience__item">
          <div className="experience__item-icon">
            <DiCss3 />
          </div>
          <div className="experience__item-text">
            <h3 className="text-light">CSS</h3>
          </div>
        </div>
        <div className="experience__item">
          <div className="experience__item-icon">
            <DiJavascript1 />
          </div>
          <div className="experience__item-text">
            <h3 className="text-light">JavaScript</h3>
          </div>
        </div>

        <div className="experience__item">
          <div className="experience__item-icon">
            <DiReact />
          </div>
          <div className="experience__item-text">
            <h3 className="text-light">React</h3>
          </div>
        </div>
        <div className="experience__item">
          <div className="experience__item-icon">
            <DiNodejs />
          </div>
          <div className="experience__item-text">
            <h3 className="text-light">NodeJs</h3>
          </div>
        </div>
        <div className="experience__item">
          <div className="experience__item-icon">
            <DiMongodb />
          </div>
          <div className="experience__item-text">
            <h3 className="text-light">MongoDB</h3>
          </div>
        </div>
        <div className="experience__item">
          <div className="experience__item-icon">
            <DiWordpress />
          </div>
          <div className="experience__item-text">
            <h3 className="text-light">Wordpress</h3>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experiences;
